export enum menuLinkNames {
    HOME = 'Home',
    SAMPLING_SUPPLIES = 'Order Sampling Supplies',
    LAB_TESTS = 'Order Lab Tests',
    HONEY_BLENDING = 'Honey Blending',
    HONEY_FORECASTING = 'Honey Forecasting',
    MY_AGENTS = 'My Agents',
    MY_JOBS = 'My Jobs',
    CONTACT_US = 'Contact Us'
}

export enum headerLinkNames {
    CONTACT_US = 'Contact Us',
    LOGIN = 'Login'
}

export class ApplicationConstants {
    public static readonly PHONE: string = '0508 44 555 22';
    public static readonly PHONE_NUMBER: string = '+645084455522';
    public static readonly EMPTY_CART = 'Your cart is empty!';
    public static readonly EXT_PHONE: string = '0508 HILL LAB (0508 44 555 22)';
    public static readonly EXT_PHONE1: string = '0508 HILL LAB';
    public static readonly EXT_PHONE2: string = '(0508 44 555 22)';
    public static readonly PHONE_GLOBAL: string = '+64 7 858 2000';
    public static readonly MAIL: string = 'mail@hill-labs.co.nz';
    public static readonly FACEBOOK: string = 'http://www.facebook.com/hill.labs';
    public static readonly LINKEDIN: string = 'http://www.linkedin.com/company/hill-laboratories';
    public static readonly OFFICIAL_PAGE: string = 'https://www.hill-labs.co.nz';
    public static readonly MY_LAB_LOGIN: string = ApplicationConstants.OFFICIAL_PAGE + '/my-lab/';
    public static readonly CONTACT_US: string = ApplicationConstants.OFFICIAL_PAGE + '/contact-us';
    public static readonly PHONE_LINK1 =
        `&lt;a class="text-email" href="tel:${ApplicationConstants.PHONE_NUMBER}"&gt;${ApplicationConstants.EXT_PHONE1}&lt;/a&gt;`;
    public static readonly PHONE_LINK2 =
        `&lt;a class="text-email" href="tel:${ApplicationConstants.PHONE_NUMBER}"&gt;${ApplicationConstants.EXT_PHONE2}&lt;/a&gt;`;
    public static readonly PHONE_LINK = `${ApplicationConstants.PHONE_LINK1} ${ApplicationConstants.PHONE_LINK2}`;
    public static readonly EMAIL_LINK =
        `&lt;a class="text-email" href="mailto:${ApplicationConstants.MAIL}"&gt;${ApplicationConstants.MAIL}&lt;/a&gt;`;

    public static readonly ACCOUNT_NOT_IN_USE_ERROR_MSG = 'You have been automatically logged out due to a problem with your account.'
        + ` Please contact our Help Desk at ${ApplicationConstants.EXT_PHONE}`;
    public static readonly ANALYTICAL_TESTS_INFO_TITLE = 'Note: not all of our tests are currently available '
    + 'in this catalogue';
    public static readonly ANALYTICAL_TESTS_DEFAULT_MSG = `&lt;p&gt;If you can't find what you're looking for, call us on
  ${ApplicationConstants.PHONE_LINK} or email us: ${ApplicationConstants.EMAIL_LINK}&lt;/p&gt;`;

    public static readonly ANALYTICAL_TESTS_NO_SUBSTANCE_MSG = 'Please select a substance';
    public static readonly ANALYTICAL_TESTS_REFINE_SUBSTANCE_MSG = 'Please refine your substance search above';

    public static readonly ANALYTICAL_TESTS_NO_RESULTS_MSG = `
    &lt;p&gt;You've found a substance for which we do perform tests, but these are not yet available in this catalogue.
    &lt;br&gt;Call us on ${ApplicationConstants.PHONE_LINK} or email us
    ${ApplicationConstants.EMAIL_LINK} to discuss your requirements&lt;/p&gt;`;

    public static readonly ANALYTICAL_TESTS_NO_RESULTS_BY_QUERY_MSG = `
    &lt;p&gt;Sorry, there are no tests that match your filter criteria.  Please review your filter or
    call us on ${ApplicationConstants.PHONE_LINK} or email us
    ${ApplicationConstants.EMAIL_LINK} to discuss your requirements&lt;/p&gt;`;

    public static readonly menuLinks = [
        { name: menuLinkNames.HOME, url: '/', external: false, id: 'menu-home' },
        { name: menuLinkNames.LAB_TESTS, url: '/lab-orders/create', external: false, id: 'menu-lab-tests' },
        { name: menuLinkNames.SAMPLING_SUPPLIES, url: '/sampling-supplies', external: false, id: 'menu-sampling-supplies' },
        { name: menuLinkNames.HONEY_BLENDING, url: '#', external: true, id: 'menu-honey-blending' },
        { name: menuLinkNames.HONEY_FORECASTING, url: '#', external: true, id: 'menu-honey-forecasting' },
        { name: menuLinkNames.MY_AGENTS, url: '/my-agents', external: false, id: 'menu-my-agents' },
        {
            name: menuLinkNames.MY_JOBS,
            url: '/orders/history',
            external: false,
            fullDocumentNavigation: true,
            id: 'menu-my-jobs'
        },
        { name: menuLinkNames.CONTACT_US, url: ApplicationConstants.CONTACT_US, external: true, id: 'menu-contact-us' }
    ];

    public static readonly headerTopLinks = [
        { name: menuLinkNames.CONTACT_US, url: ApplicationConstants.CONTACT_US, external: true }
    ];

    public static readonly footerMenus = [
        {
            name: 'CONTACT US',
            links : [
                { name: ApplicationConstants.EXT_PHONE, url: 'tel:' + ApplicationConstants.PHONE_NUMBER, external: true },
                { name: ApplicationConstants.PHONE_GLOBAL, url: 'tel:' + ApplicationConstants.PHONE_GLOBAL, external: true },
                { name: ApplicationConstants.MAIL, url: 'mailto:' + ApplicationConstants.MAIL, external: true },
            ]
        },
        {
            name: 'QUICK LINKS',
            links :
      [
          { name: 'Terms of Trade', url: ApplicationConstants.OFFICIAL_PAGE + '/TermsOfTrade', external: true },
          { name: 'End-User Licence Agreement', url: ApplicationConstants.OFFICIAL_PAGE + '/OnlineTerms', external: true },
          { name: 'Privacy Statement', url: ApplicationConstants.OFFICIAL_PAGE + '/PrivacyStatement', external: true },
      ]
        },
        {
            name: 'SITE MAP',
            links :
      [
          { name: 'Home', url: '/', external: false },
          { name: 'Order Lab Tests', url: '/lab-orders/create', external: false },
          { name: 'Order Sampling Supplies', url: '/sampling-supplies', external: false },
          { name: 'My Jobs', url: '/orders/history', external: false, fullDocumentNavigation: true },
      ]
        }
    ];

    public static readonly COPYRIGHT: string = '© Copyright ' + new Date().getFullYear() + ', R J Hill Laboratories Limited';
    public static readonly HILL_LABORATORIES: string = 'Hill Laboratories';
    public static readonly MAX_QUANTITY = 99;

    public static readonly PROGRESS_DISCLAIMER: string =
        'Please note that the progress percentage displayed is a measure of the number of activities '
        + 'complete on the job versus the number of activities yet to be completed.'
        + ' This does not relate to the turnaround time of those activities.';
    public static readonly PRICE_DISCLAIMER: string =
        'Changes to the substance selected and/or the test selection, may result in changes to your price shown.'
        + ' For any test not displaying a price, please add it to your cart to see the price.';
}

export class SamplingTypeFilter {
    public static readonly MULTISELECT_SELECTED_ALL = ' - ANY - ';
    public static readonly MULTISELECT_SELECTED_SOME = '{0} items selected';
    public static readonly MULTISELECT_SELECTED_DEFAULT = ' - ANY - ';
}

export class CartConstants {
    public static readonly SAMPLING_SUPPLIES_GROUP_NAME = 'Sampling Supplies';
    public static readonly RECOMMENDED_SUPPLIES_GROUP_NAME = 'Recommended Sampling Supplies';
    public static readonly CURRENCY = 'NZD';
}

export const CUSTOM_CLAIM_ROLES = 'https://mylab.hill-labs.co.nz/claims/roles';
export const COGNITO_GROUPS_CLAIM = 'cognito:groups';

export const HTTP_STATUS_404 = 404;

export const COUNTRY = 'New Zealand';

export const ONLINE_TERMS_URL = '/pages/online-terms-and-conditions';
export const TERMS_OF_TRADE_URL = ApplicationConstants.OFFICIAL_PAGE + '/TermsOfTrade';

export class OrderSuccessMessages {
    public static readonly STANDARD = 'You will receive confirmation of this order in your email shortly.';
    public static readonly UNCONFIRMED = 'Your order will be processed once your account is confirmed.<br>' +
      'You will then receive confirmation of this order in your email.';
}

export class AuthConstants {
    public static readonly PROFILE_LOCAL_STORAGE_KEY = 'userProfile';
    public static readonly AUTH_TOKEN_LOCAL_STORAGE_KEY = 'authToken';
    public static readonly LOGGED_IN_CONTACT_LOCAL_STORAGE_KEY = 'loggedInContact';
    public static readonly OPT_AS_GUEST_STORAGE_KEY = 'optAsGuest';
}

export class AuthErrorMessages {
    public static readonly CONTACT_GENERIC_ERROR = 'Something went wrong when trying to log you in.'
        + ' Please try again.'
        + ' If this persists, please contact us at <a href="mailto:mail@hill-labs.co.nz">mail@hill-labs.co.nz</a>'
        + ' or <a href="tel:05084455522">0508 HILL LAB (0508 44 555 22)</a> so we can assist you.';
    public static readonly CONTACT_NOT_IN_USE_ERROR = 'You cannot login to MyLab because your account is marked as inactive.'
        + ' Please contact us at <a href="mailto:mail@hill-labs.co.nz">mail@hill-labs.co.nz</a>'
        + ' or <a href="tel:05084455522">0508 HILL LAB (0508 44 555 22)</a> so we can assist you.';
}

export enum TargetDateMarkers {
    QOWQED_TOOLTIP = 'Tests on this job may have been repeated for quality checking purposes.'
        + ' This may impact the accuracy of the Target Date.',
    QOWQED_CODE = 'Q',
    HOLDING_TOOLTIP = 'This job is on hold.'
        + ' Essentially this means all testing has been paused, usually awaiting client feedback.',
    HOLDING_CODE = 'H',
    HOLDING_REPORT_TOOLTIP = 'This job has its reports on hold.'
        + ' This means the tests are continuing as usual, but the report will not be released yet.'
        + ' Sometimes this is due to awaiting client feedback.',
    HOLDING_REPORT_CODE = 'HR'
}

export const MAX_ORDER_SAMPLES = 100;

export const STATUS_MESSAGE_LOCALSTORAGE_KEY = 'statusMessage';
